import SelectionCombination from './SelectedCombination';

export { SelectionCombination };
